import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Pain } from './components/Pain';
import { Stats } from './components/Stats';
import { Revelation } from './components/Revelation';
import { Benefits } from './components/Benefits';
import { Industries } from './components/Industries';
import { About } from './components/About';
import { HowItWorks } from './components/HowItWorks';
import { MainCTA } from './components/MainCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background text-text-primary selection:bg-primary/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Pain data-id="element-4" />
        <Stats data-id="element-5" />
        <Revelation data-id="element-6" />
        <Benefits data-id="element-7" />
        <Industries data-id="element-8" />
        <About data-id="element-9" />
        <HowItWorks data-id="element-10" />
        <MainCTA data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}